import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { BodyListResponse } from 'src/app/core/models/general/body-list-response';
import { BodyResponse } from 'src/app/core/models/general/body-response';
import { PersonalEntidadBeneficiariaDTO } from 'src/app/core/models/vinculacion/vinculacion-Interfaces';



import { environment } from 'src/environments/environment';

const API_URL = environment.apiUrlVinculacion;

@Injectable()
export class PersonalEntidadBeneficiariaService {
  header = new Headers({ 'Content-Type': 'application/json' });

  constructor(private http: HttpClient) {}

  getPersonalEntidadBeneficiariaService(): Observable<BodyListResponse<PersonalEntidadBeneficiariaDTO>> {
    return this.http.get<BodyListResponse<PersonalEntidadBeneficiariaDTO>>(API_URL + '/api/v1/personalEntidadBeneficiaria/todos');
  }

  getPersonalEntidadBeneficiariaporEntidadService(codigo:string): Observable<BodyListResponse<PersonalEntidadBeneficiariaDTO>> {
    return this.http.get<BodyListResponse<PersonalEntidadBeneficiariaDTO>>(API_URL + '/api/v1/personalEntidadBeneficiaria/entidad/'+codigo);
  }

  guardarPersonalEntidadBeneficiariaService(personalEntidadBeneficiariaDTO: PersonalEntidadBeneficiariaDTO): Observable<BodyResponse<PersonalEntidadBeneficiariaDTO>> {
    return this.http.post<any>(API_URL + '/api/v1/personalEntidadBeneficiaria', personalEntidadBeneficiariaDTO);
  }

  getPersonalEntidadBeneficiariaPorCodigoPersonalEntidadBenefService(codigoPersonalEntidadBenef: string): Observable<BodyResponse<PersonalEntidadBeneficiariaDTO>> {
    return this.http.get<BodyResponse<PersonalEntidadBeneficiariaDTO>>(API_URL + '/api/v1/personalEntidadBeneficiaria/' + codigoPersonalEntidadBenef);
  }
}
